import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Prescription, PrescriptionData, PrescriptionFilter } from "./models/PrescriptionsModel";

export default class ExampleVuexModule extends AbacoVuexModule {
    @State() curPrescription!: Prescription | null;
    @State() selectedPrescriptionType!: string | null;
    @State() prescriptionData!: PrescriptionData | null;
    @State() editingPrescription!: boolean;
    @State() prescriptionsFilters!: PrescriptionFilter | null;
}
